import React from 'react';
import { FormGroup, Label, Input, Button, Row, Col } from 'reactstrap';

const CampaignFlowTab = ({ campaignFlow = {}, updateLocalCampaignFlowConfig }) => {
    const {
        type: campaignFlowType = 'interactive',
        breakpoints: campaignFlowBreakpoints = [],
        altText: campaignFlowAltText = undefined,
    } = campaignFlow;

    return (
        <div>
            {/* Section: Campaign Flow */}
            <div className="mb-4">
                <h2 className="h6 text-uppercase text-muted fw-bold border-bottom pb-2 mb-3">Kampagnenablauf</h2>
                <FormGroup className="mb-3">
                    <Label for="campaignFlowType">Ablauf-Darstellungstyp</Label>
                    <Input
                        type="select"
                        id="campaignFlowType"
                        value={campaignFlowType || 'interactive'}
                        onChange={(e) => updateLocalCampaignFlowConfig({ type: e.target.value })}
                    >
                        <option value="interactive">Interaktive Phasenschritte (Code)</option>
                        <option value="graphic">Eigene hochgeladene Grafik</option>
                    </Input>
                </FormGroup>

                {campaignFlowType === 'graphic' && (
                    <div className="ps-3 border-start mb-3">
                        <div className="mb-2 text-muted small">Grafik-Breakpoints:</div>
                        {(campaignFlowBreakpoints || []).map((bp, idx) => (
                            <div key={idx} className="p-3 border rounded mb-3 bg-white">
                                <Row className="g-2 mb-2">
                                    <Col xs="4">
                                        <Label className="small text-muted mb-1">Min. Breite (px)</Label>
                                        <Input
                                            type="number"
                                            value={bp.minWidth}
                                            onChange={(e) => {
                                                const newBps = [...(campaignFlowBreakpoints || [])];
                                                newBps[idx] = {
                                                    ...newBps[idx],
                                                    minWidth: parseInt(e.target.value, 10) || 0,
                                                };
                                                updateLocalCampaignFlowConfig({ breakpoints: newBps });
                                            }}
                                            placeholder="Min. Breite"
                                        />
                                    </Col>
                                    <Col xs="4">
                                        <Label className="small text-muted mb-1">Skalierung</Label>
                                        <Input
                                            type="number"
                                            value={bp.scale !== undefined && bp.scale !== null ? bp.scale : 1}
                                            min={0.1}
                                            max={2}
                                            step={0.05}
                                            onChange={(e) => {
                                                const newBps = [...(campaignFlowBreakpoints || [])];
                                                newBps[idx] = {
                                                    ...newBps[idx],
                                                    scale: parseFloat(e.target.value) || 1,
                                                };
                                                updateLocalCampaignFlowConfig({ breakpoints: newBps });
                                            }}
                                            placeholder="Skalierung"
                                        />
                                    </Col>
                                    <Col xs="4">
                                        <Label className="small text-muted mb-1">Max. Höhe (px)</Label>
                                        <Input
                                            type="number"
                                            value={
                                                bp.maxHeight !== undefined && bp.maxHeight !== null ? bp.maxHeight : ''
                                            }
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                const newBps = [...(campaignFlowBreakpoints || [])];
                                                newBps[idx] = {
                                                    ...newBps[idx],
                                                    maxHeight: val === '' ? undefined : parseInt(val, 10) || undefined,
                                                };
                                                updateLocalCampaignFlowConfig({ breakpoints: newBps });
                                            }}
                                            placeholder="Automatisch"
                                        />
                                    </Col>
                                </Row>
                                <Row className="g-2 mb-2">
                                    <Col xs="6">
                                        <Label className="small text-muted mb-1">Fokuspunkt X (%)</Label>
                                        <Input
                                            type="number"
                                            value={
                                                bp.focalPoint?.x !== undefined && bp.focalPoint?.x !== null
                                                    ? bp.focalPoint.x
                                                    : 50
                                            }
                                            min={0}
                                            max={100}
                                            onChange={(e) => {
                                                const newBps = [...(campaignFlowBreakpoints || [])];
                                                newBps[idx] = {
                                                    ...newBps[idx],
                                                    focalPoint: {
                                                        x: parseInt(e.target.value, 10) || 0,
                                                        y: bp.focalPoint?.y !== undefined ? bp.focalPoint.y : 50,
                                                    },
                                                };
                                                updateLocalCampaignFlowConfig({ breakpoints: newBps });
                                            }}
                                            placeholder="Fokuspunkt X"
                                        />
                                    </Col>
                                    <Col xs="6">
                                        <Label className="small text-muted mb-1">Fokuspunkt Y (%)</Label>
                                        <Input
                                            type="number"
                                            value={
                                                bp.focalPoint?.y !== undefined && bp.focalPoint?.y !== null
                                                    ? bp.focalPoint.y
                                                    : 50
                                            }
                                            min={0}
                                            max={100}
                                            onChange={(e) => {
                                                const newBps = [...(campaignFlowBreakpoints || [])];
                                                newBps[idx] = {
                                                    ...newBps[idx],
                                                    focalPoint: {
                                                        x: bp.focalPoint?.x !== undefined ? bp.focalPoint.x : 50,
                                                        y: parseInt(e.target.value, 10) || 0,
                                                    },
                                                };
                                                updateLocalCampaignFlowConfig({ breakpoints: newBps });
                                            }}
                                            placeholder="Fokuspunkt Y"
                                        />
                                    </Col>
                                </Row>
                                <Row className="g-2 align-items-end">
                                    <Col>
                                        <Label className="small text-muted mb-1">Grafik-URL</Label>
                                        <Input
                                            type="text"
                                            value={bp.url}
                                            onChange={(e) => {
                                                const newBps = [...(campaignFlowBreakpoints || [])];
                                                newBps[idx] = { ...newBps[idx], url: e.target.value };
                                                updateLocalCampaignFlowConfig({ breakpoints: newBps });
                                            }}
                                            placeholder="Grafik-URL"
                                        />
                                    </Col>
                                    <Col xs="auto">
                                        <Button
                                            color="danger"
                                            onClick={() => {
                                                const newBps = (campaignFlowBreakpoints || []).filter(
                                                    (_, i) => i !== idx
                                                );
                                                updateLocalCampaignFlowConfig({ breakpoints: newBps });
                                            }}
                                        >
                                            Löschen
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        ))}
                        <Button
                            color="primary"
                            outline
                            className="w-100"
                            onClick={() => {
                                const newBps = [...(campaignFlowBreakpoints || []), { minWidth: 768, url: '' }];
                                updateLocalCampaignFlowConfig({ breakpoints: newBps });
                            }}
                        >
                            Breakpoint hinzufügen
                        </Button>
                    </div>
                )}

                <FormGroup switch className="mb-2">
                    <Input
                        type="switch"
                        id="campaignFlowAltTextSwitch"
                        checked={campaignFlowAltText === ''}
                        onChange={(e) => {
                            if (e.target.checked) {
                                updateLocalCampaignFlowConfig({ altText: '' });
                            } else {
                                updateLocalCampaignFlowConfig({ altText: undefined });
                            }
                        }}
                    />
                    <Label check for="campaignFlowAltTextSwitch">
                        Als dekorativ markieren (leerer Alt-Text)
                    </Label>
                </FormGroup>

                {campaignFlowAltText !== '' && (
                    <FormGroup className="mb-3">
                        <Label for="campaignFlowAltText">Kampagnenablauf-Alt-Text</Label>
                        <Input
                            type="text"
                            id="campaignFlowAltText"
                            value={
                                campaignFlowAltText !== undefined && campaignFlowAltText !== null
                                    ? campaignFlowAltText
                                    : ''
                            }
                            onChange={(e) => {
                                const val = e.target.value;
                                updateLocalCampaignFlowConfig({ altText: val === '' ? undefined : val });
                            }}
                            placeholder="Standard: Kampagnenablauf"
                        />
                    </FormGroup>
                )}
            </div>
        </div>
    );
};

export default CampaignFlowTab;
